import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import {
  STANDALONE_QUERY,
  STANDALONE_STORAGE_KEY,
  isStandaloneChrome,
} from '../lib/standaloneChrome';

function readStoredFlag(): string | null {
  try {
    return sessionStorage.getItem(STANDALONE_STORAGE_KEY);
  } catch {
    return null;
  }
}

function persistFromSearch(search: string): void {
  const raw = search.startsWith('?') ? search.slice(1) : search;
  if (new URLSearchParams(raw).get(STANDALONE_QUERY) !== '1') return;
  try {
    sessionStorage.setItem(STANDALONE_STORAGE_KEY, '1');
  } catch {
    // sessionStorage indisponible : le query param suffit pour ce chargement.
  }
}

/** Chrome cabinet retiré pour cet onglet (flag query puis sessionStorage). */
export function useStandaloneChrome(): boolean {
  const { search } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  persistFromSearch(search);
  const standalone = isStandaloneChrome(search, readStoredFlag());

  useEffect(() => {
    if (searchParams.get(STANDALONE_QUERY) !== '1') return;
    const next = new URLSearchParams(searchParams);
    next.delete(STANDALONE_QUERY);
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams]);

  return standalone;
}
